import { render, staticRenderFns } from "./worSearch.vue?vue&type=template&id=6e5a61ce"
import script from "./worSearch.vue?vue&type=script&lang=ts"
export * from "./worSearch.vue?vue&type=script&lang=ts"
import style0 from "./worSearch.vue?vue&type=style&index=0&id=6e5a61ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports